<template>
    <div class="organization"  >
      <!-- <h1>acquirer</h1> -->

      <v-row no-gutters>

        <v-col cols="auto" class="me-auto" >
          <!-- <v-sheet class="ma-2 pa-2">Acquirer</v-sheet> -->
          <v-sheet class="ma-2 pa-2">
            <v-breadcrumbs :items="['Acq level Devices']"></v-breadcrumbs> 
          </v-sheet>        
        </v-col>       
        <v-col cols="auto">
          <v-sheet class="ma-2 pa-2">            
            <v-btn prepend-icon="mdi-plus" color="primary" to="/add-device" v-if="this.global_permissions.includes('ROLE_USER_ADMIN', 'ROLE_MOD_DEVICE') ">              
              <template v-slot:prepend >
                <v-icon color="white"></v-icon>
                <!-- <router-link to="/add-device" > Add Device </router-link> -->
              </template>
              Add Device
            </v-btn>      
          </v-sheet>
        </v-col>
        <v-col cols="auto">
          <v-sheet class="ma-2 pa-2">
            <v-btn color="primary" prepend-icon="mdi-upload" @click="compose_excel" v-if="this.global_permissions.includes('ROLE_USER_ADMIN', 'ROLE_UPLOAD_DEVICE')">              
                <template v-slot:prepend >
                  <v-icon color="black"></v-icon>
                </template>
                Batch Upload
              </v-btn>     
          </v-sheet>
        </v-col>   
      
      </v-row>

      <v-row class="search_row">
            <v-col cols="3" >                                 
              <v-text-field                
                append-inner-icon="mdi-close-circle" 
                append-icon="mdi-magnify"                         
                density="compact"
                label="Search"
                variant="solo"
                hide-details
                single-line
                dense
                v-model="query"
                @click:append-inner="resetData"
                @click:append="searchDevice"
              ></v-text-field>                                             
            </v-col> 
            <v-col cols="4">                              
              <v-row justify="center" align="center">
                <v-col cols="auto">
                  <h5>Export : </h5>
                </v-col>
                <v-col cols="auto">
                  <!-- excel-->
                  <download-excel
                    class="btn btn-default"
                    :data="devices"
                    :fields="json_fields"
                    worksheet="My Worksheet"
                    name="filename.xls"
                  >
                    <v-btn density="compact">xls</v-btn>
                  </download-excel>
                </v-col>

                <v-col cols="auto">
                  <!-- cvs -->
                  <download-excel
                    class="btn btn-default"
                    :data="devices"
                    :fields="json_fields"
                    worksheet="My Worksheet"
                    type="csv"
                    name="filename.xls"
                  >
                    <v-btn density="compact">csv</v-btn>
                  </download-excel>
                </v-col>

                <v-col cols="auto">
                  
                </v-col>
              </v-row> 
            </v-col>
      </v-row>    

      <v-card>
        <v-card-title>
          
          <v-spacer></v-spacer>
                
        </v-card-title>

        <v-data-table
          :headers="headers"
          :items="devices"        
          class="elevation-1 custom-table-style"
          :search="search"

          :items-per-page="itemsPerPage" 
          :items-length="totalItems"          
          disable-pagination
          :hide-default-footer="true"
          :fixed-header="true"
          :loading="loading"
          
        >  
          <template v-slot:item.tid="{ item }">            
              <td >
                <tr v-for="it in item.raw.merchantDetails" :key="it.id">                  
                  <td >{{it.tid}}</td>
                </tr>
              </td>
          </template> 
          
          <template v-slot:item.mid="{ item }">            
              <td >
                <tr v-for="it in item.raw.merchantDetails" :key="it.id">                  
                  <td >{{it.mid}}</td>
                </tr>
              </td>
          </template> 

          <template v-slot:item.currencyName="{ item }">       
              
              <p v-for="it in item.raw.merchantDetails" :key="it.id">{{it.currency.currencyName}}</p>
          </template> 

          <!-- <template v-slot:item.actions="{ item }">              
              <router-link :to="/update-device/+item.raw.id" v-if="this.global_permissions.includes('ROLE_USER_ADMIN', 'ROLE_MOD_DEVICE') "> <v-icon color="green" small class="mr-2" >mdi-pencil</v-icon></router-link>
              
              <v-icon color="red" small @click="compose_delete(item.raw.id)" v-if="this.global_permissions.includes('ROLE_USER_ADMIN', 'ROLE_MOD_DEVICE') ">mdi-delete</v-icon>
          </template> -->

          <template v-slot:item.actions="{ item }">            
               
               <v-tooltip text="Update" location="top">
                 <template v-slot:activator="{ props }"> 
                   <router-link :to="/update-device/+item.raw.id" v-if="this.global_permissions.includes('ROLE_USER_ADMIN', 'ROLE_MOD_DEVICE') "> <v-icon v-bind="props" small class="mr-2" color="blue" >mdi-pencil-circle</v-icon></router-link>                
                   
                 </template>
               </v-tooltip>
               <v-tooltip text="Delete" location="top">
                 <template v-slot:activator="{ props }">                  
                   <v-icon v-bind="props" small class="mr-2" color="red" @click="compose_delete(item.raw.id)" v-if="this.global_permissions.includes('ROLE_USER_ADMIN', 'ROLE_DEL_DEVICE')">mdi-delete-circle</v-icon>
                 </template>
               </v-tooltip>
           </template>
 
           <template v-slot:bottom>
             <div class="text-center pt-2">
               <v-pagination
                 v-model="page"
                 :length="pageCount"
                 total-visible="7"            
                 @update:model-value="page"              
                                      
               ></v-pagination>
             </div>
           </template>
          

        </v-data-table>
      </v-card>

      <!-- <v-table>
        <thead>
          <tr>         
            
            <th>deviceSN</th>
            <th>TID</th>
            <th>MID</th>           
            <th>Merchant Name</th>
            <th>Merchant Address</th> 
            <th>Acquirer</th>
            <th>Date created</th>
            <th>Date Updated</th>                     
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in devices" :key="item.id">      
            <td>{{item.deviceSN}}</td>
            <td >
              <tr v-for="it in item.merchantDetails" :key="it.id">
                <td >{{it.tid}}</td>
              </tr>              
            </td>
            <td >
              <tr v-for="it in item.merchantDetails" :key="it.id">
                <td >{{it.mid}}</td>
              </tr>              
            </td>
            
            <td>{{item.merchants.merchantName}}</td>
            <td>{{item.merchants.merchantAddress}}</td>
            <td>{{item.merchants.acquirer.acquirerName}}</td>
            <td>{{item.dateCreated}}</td>
            <td>{{item.dateUpdated}}</td>            
            <td>              
              <v-btn><router-link :to="/update-device/+item.deviceId"> Update</router-link></v-btn>
              <v-btn @click="compose_delete(item.deviceId)">Delete</v-btn>
            </td>
            
          </tr>
        </tbody>
      </v-table>     -->
      

      <!-- ADD DIALOG -->
      <!-- <v-dialog
              v-model="dialog"
              persistent
              width="1024"
            >
              
              <v-card>
                <v-card-title>
                  <span class="text-h5">Add Role</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12">                                 
                        <v-text-field label="Day name*" required v-model="role_data.f_roleName" ></v-text-field>                                              
                      </v-col>
                      <v-col cols="12">                                 
                        <v-select
                          :items="organization"
                          item-title="orgName"
                          item-value="orgId"                          
                          label="Select Organization*"                          
                          required
                          v-model="role_data.f_orgId"
                        ></v-select>                      
                      </v-col>
                      <v-col cols="12">                                 
                        <v-autocomplete
                          :items="permissions"
                          item-title="perName"
                          item-value="perId"
                          label="Select permissions"
                          multiple
                          v-model="role_data.f_perList"
                        ></v-autocomplete>                       
                      </v-col>

                      
                    </v-row>
                  </v-container>
                  <small>*indicates required field</small>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="blue-darken-1"
                    variant="text"
                    @click="dialog = false"
                  >
                    Close
                  </v-btn>
                  <v-btn
                    color="blue-darken-1"
                    variant="text"
                    @click="addRole"
                  >
                    Save
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog> -->
            <!-- END ADD DIALOG -->

      <!-- UPDATE  DIALOG -->
      <!-- <v-dialog
              v-model="dialog_update"
              persistent
              width="1024"
            >              
              <v-card>
                <v-card-title>
                  <span class="text-h5">Update Day</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12">                                 
                        <v-text-field label="Day name*" required v-model="role_data.f_roleName" ></v-text-field>                                              
                      </v-col>
                      <v-col cols="12">                                 
                        <v-select
                          :items="organization"
                          item-title="orgName"
                          item-value="orgId"                          
                          label="Select Organization*"                          
                          required
                          v-model="role_data.f_orgId"
                        ></v-select>                      
                      </v-col>
                      <v-col cols="12">                                 
                        <v-autocomplete
                          :items="permissions"
                          item-title="perName"
                          item-value="perId"
                          label="Select permissions"
                          multiple
                          v-model="role_data.f_perList"
                        ></v-autocomplete>                       
                      </v-col>
                      
                    </v-row>
                  </v-container>
                  <small>*indicates required field</small>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="blue-darken-1"
                    variant="text"
                    @click="dialog_update = false"
                  >
                    Close
                  </v-btn>
                  <v-btn
                    color="blue-darken-1"
                    variant="text"
                    @click="updateRole"
                  >
                    Update
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog> -->
            <!-- END UPDATE  DIALOG -->
      
      <!-- DELETE  DIALOG -->
      <!-- <v-dialog
              v-model="dialog_delete"
              persistent
              width="500"
            >              
              <v-card>
                <v-card-title>
                  <span class="text-h5">do you want to delete?</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                                           
                    </v-row>
                  </v-container>
                  
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="blue-darken-1"
                    variant="text"
                    @click="dialog_delete = false"
                  >
                    Close
                  </v-btn>
                  <v-btn
                    color="blue-darken-1"
                    variant="text"
                    @click="deleteRole"
                  >
                    Delete
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog> -->
            <!-- END UPDATE DIALOG -->

             
    <!-- UPLOAD  DIALOG -->      
    <v-dialog v-model="dialog_excel" persistent width="500"  > 
           
            <v-card>
              <span style="text-align: center;">Batch Upload</span> 
              <span style="text-align: center;">
                    <!-- THIS ALLOWS ME TO DOWNLOAD .XLS FILE -->
                    <!-- <download-excel
                      class="btn btn-default"
                      :data="template_merchants"
                      :fields="template_json_fields"
                      worksheet="Merchants"
                      name="Merchants.xls"
                    >
                      <v-btn density="compact" color="black">Download Merchant Template</v-btn>
                    </download-excel> -->
                    <!-- THIS ALLOWS ME TO DOWNLOAD .XLXS FILE -->
                    <vue-excel-xlsx
                      class="btn btn-default"
                      :data="data1"
                      :columns="template_columns"
                      :file-name="'Devices'"
                      :file-type="'xlsx'"
                      :sheet-name="'Devices'"                        
                    >
                      <v-btn density="compact" color="black">Download Template</v-btn>
                      <!-- Download Template -->
                    </vue-excel-xlsx>
              </span>
              <v-form v-model="form" @submit.prevent="onSubmit">
                <v-card-title>
                                      
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <!-- <v-file-input show-size clearable label="File input" v-model="file" @change="handleFileUpload( $event )"></v-file-input> -->
                      <v-file-input show-size clearable label="File input" @change="handleFileUpload( $event )"></v-file-input>                      
                    </v-row>
                  </v-container>
                  
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn variant="text" @click="dialog_excel = false">Close</v-btn>                  
                  <v-btn color="blue-darken-1" variant="text" @click="uploadDeviceFile">Upload</v-btn>                  
                </v-card-actions>
              </v-form>
              <small style="color: red;"> *File size should not be above 2MB</small>
              <small style="color: red;"> After downloading Save .xlxs file before storing data</small>
            </v-card>
    </v-dialog>             


    </div>
  </template>
  
  <script>
  import axios from 'axios'
  export default {
    name: 'Role',
    props: {
      msg: String ,
      //victor : Boolean ,
      //ID: String, 
      name: String,   //this represent the acq id from DeviceDetails component  
    },
    data(){
      return {
        //name: '',       
        devices: [],  //used
        organization: [],
        permissions: [], 
        
        
        dialog: false,
        dialog_update: false,
        dialog_delete: false,

        dialog_excel: false,

        role_data:{  //used
          f_roleName: '',
          f_orgId: '',
          f_perList: [],
          
        },

        deviceId: '',       
        search: '',
        headers: [
        {
            title: 'Device SN',
            align: 'start',
            sortable: false,
            key: 'deviceSN',
          },
          { title: 'Merchant Name', key: 'merchant.merchantName' },
          { title: 'Merchant Address', key: 'merchant.merchantAddress' },
          { title: 'TID', key: 'tid' },
          { title: 'MID', key: 'mid' },
          { title: 'Currency', key: 'currencyName' },          
          //{ title: 'Acquirer', key: 'merchant.acquirer.acquirerName' },
          //{ title: 'Date Created', key: 'dateCreated' },
          { title: 'Date Updated', key: 'updatedAt' },          
          //{ title: 'Organization', key: 'merchant.acquirer.organization.orgName' },          
          //{ title: 'Actions', key: 'acquirerId', sortable: false },
          { title: 'Actions', key: 'actions', sortable: false, width: '100px' },
        ],

        //FOR EXPORT
        json_fields: {
              "Device SN": "deviceSN",
              "Merchant Name": "merchants.merchantName",                          
              "Merchant Address": "merchants.merchantAddress",              
              "TID": {
                  field: "merchantDetails",
                      callback: (value) => {
                        //console.log("ss length", value.length)
                        let i = 0;
                        let value1 = '';
                        if(value != null && value.length == 1){
                          value1 = value[i].tid
                        }
                        // if(value != null && value.length == 2){
                        //   value2 = value[0].tid +"\n"+value[1].tid
                        // }
                        if(value != null && value.length > 1){
                          for(i=0; i<value.length; i++){
                            //value2 = value[i].tid +" , "+value2 
                            value1 = value[i].tid +"\n"+value1                            
                          }
                        }
                        
                      //return `Landline Phone - ${value[0].tid}`;
                      return `${value1}`;

                  },
                    
              },
              "MID": {
                  field: "merchantDetails",
                      callback: (value) => {
                        //console.log("ss length", value.length)
                        let u = 0;
                        let value2 = '';
                        if(value != null && value.length == 1){
                          value2 = value[u].mid
                        }
                        // if(value != null && value.length == 2){
                        //   value2 = value[0].mid +"\n"+value[1].mid
                        // }
                        if(value != null && value.length > 1){
                          for(u=0; u<value.length; u++){
                            //value2 = value[u].mid +" , "+value2
                            value2 = value[u].mid +"\n"+value2                            
                          }
                        }
                        
                      //return `Landline Phone - ${value[0].tid}`;
                      return `${value2}`;

                  },
                    
              },
              "Currency": {
                  field: "merchantDetails",
                      callback: (value) => {
                        //console.log("ss length", value.length)
                        let w = 0;
                        let value3 = '';
                        if(value != null && value.length == 1){
                          value3 = value[w].currency.currencyName
                        }
                        // if(value != null && value.length == 2){
                        //   value2 = value[0].mid +"\n"+value[1].mid
                        // }
                        if(value != null && value.length > 1){
                          for(w=0; w<value.length; w++){
                            //value2 = value[u].currency.currencyName +" , "+value2                            
                            value3 = value[w].currency.currencyName +"\n"+value3 
                            console.log("device_currency", value3)                           
                          }
                        }
                        
                      //return `Landline Phone - ${value[0].tid}`;
                      return `${value3}`;

                  },
                    
              },
              "Acquirer name": "merchants.acquirer.acquirerName",
              "Created At": "dateCreated",
              "Updated At": "dateUpdated",
              "Organization": "merchants.acquirer.organization.orgName"
        },



        //snackbar
        snackbar: false,
        snackbar_text: '',
        snackbar_color: '',

        //THIS IS USED TO CREATE A TEMPLATE XLXS FILE FOR DOWNLOAD
        //THE FIELD HAS TO BE ACCORDING TO THE NAMING IN THE ENTITY CLASS
        //NB: THE USER HAS TO DOWNLOADED ET RE SAVE  THE .XLXS FILE BEFORE IT WILL WORK
        template_columns: [
            {
              label: "deviceSN",
              field: "deviceSN",
            },
            {
              label: "Merchant ID",
              field: "merchant.id",              
            },
            {
              label: "TID_1",
              field: "tid",
            },
            {
              label: "MID_1",
              field: "mid",
            },
            {
              label: "Currency Code",
              field: "currency",
            },
            {
              label: "CVM_1",
              field: "cvm",
            },                     
            {
              label: "Operations",
              field: "allowedOperations",
            },
            {
              label: "Stlm Days",
              field: "settleDays",
            },
            {
              label: "Stment Time",
              field: "stmTime",
            },
            {
              label: "Receipt Number",
              field: "receiptNumber",
            },
            {
              label: "Dual Currency",
              field: "dualCurrency",
            },
            {
              label: "Created By",
              field: "createdBy",
            }
            
            
        ],
        // data1   HERE IS ACCORDING THE MERCHANT ENTITY 
        data1 : [
          {
            deviceSN: "",
            merchantAddress: "",
            mcc: {
              mccCode: ''                        
            },
            acquirer: {
              id: '',                        
            },
            createdBy: ""
            
          },
                    
        ],


        //pagination        
        page: 1,
        itemsPerPage: 5,
        totalItems:0,
        totalPages:0,
        query: '',
        loading: false,

        


      }
    },

    computed: {
      flatItems() {
         return this.devices.reduce(function(acc, v) {
            // console.log("per_object3", [...acc, ...v.merchantDetails])
            return [...acc, ...v.merchantDetails]
            
         }, [])
      },


      pageCount () {        
        // console.log("ssss", this.totalItems + " / "+ this.itemsPerPage); 
        let count = Math.ceil(this.totalItems / this.itemsPerPage) 
        // console.log("ssss11 count : ", count);      
        //return Math.ceil(this.totalItems / this.itemsPerPage)
        return count;
      }, 

      
    },

    watch:{
        page(newPage){ 
          this.page = newPage         
          this.fetchData()
          // console.log("new page", this.page)          
        },

        onUpdatePageHandler(newPage) {
          this.page = newPage
          //this.fetchData()
        },

        onItemsPerPageChange (newItemsPerPage){
          this.itemsPerPage = newItemsPerPage
          this.fetchData()
        },
       
        
    },

    created () {
      
    },

    methods:{

      resetData() {
        this.query= ''
        this.fetchData()
      },

      onSubmit () {
        if (!this.form) return
        
      },

      compose_delete(id) {
          this.deviceId = id
          this.dialog_delete = true                   
      },  
      
      compose_excel() {
          this.dialog_excel = true                  
      },
      
      

      async deleteRole() {
          this.dialog_delete = false 
          try{         
            let result = await axios.delete(window.baseurl+""+"devices/" +this.deviceId ,
                  {"headers": {'Authorization': 'Bearer ' + this.accessToken}}
                  );          
            if (result.status == 200) {
                //alert("successfull deleted"); 
                this.show_toast(true, "success", "Deleted");
                window.setInterval(() => {
                      this.$router.go();
                }, 7000)
                //this.$router.go();             
            }
          }
          catch (error){            
            this.show_toast(true, "warning", error.message);
          }
      },


      //UPLOAD FILE

      handleFileUpload( event ){
        this.file = event.target.files[0];
      },

      async uploadDeviceFile() {
          this.checkTokenExpiry();
          // console.log("file" + this.file);

          if (this.file) {
            let formData = new FormData();
            formData.append('file', this.file);
            try{
              let result = await axios.post(window.baseurl+"devices/upload", formData ,
                {"headers": { 'Authorization': 'Bearer ' + this.accessToken , 'content-type': 'multipart/form-data' }}
              );
              //console.warn("result", result);
              if (result.status == 200) {
                  //alert("successfull");                  
                  //this.show_toast(true, "success", "Successful");
                  this.$root.vtoast.show({message: result.data.message})
                  window.setInterval(() => {
                    this.dialog_excel = false
                      this.$emit("reload")
                  }, this.waiting_time)
                  
              }
            }
            catch (error){            
              //this.show_toast(true, "warning", error.message);
              this.$root.vtoast.showError({message: error.message})
            }
            
          }else{
            // console.log("there are no files.");
            this.$root.vtoast.showError({message: "There are no files"})
          }
      
          
          
      },


      async fetchData() {        

        let result;
        let page2 = this.page - 1;
        try{

          /* if(this.global_permissions.includes("ROLE_STAFF_ADMIN", 'ROLE_STAFF_USER')){            
            result = await axios.get(window.baseurl+"devices", {
              params: { page: page2  },
              headers: { 'Authorization': 'Bearer ' + this.accessToken  }            
            }) 
            
            console.log("device_object", result);
            this.devices = result.data.records; 
            this.totalItems = result.data.totalRecords 
            this.itemsPerPage = result.data.pageSize
            this.totalPages = result.data.totalPages
          } */
          if(this.global_permissions.includes("ROLE_USER_ADMIN", 'ROLE_VIEW_DEVICE')){
            /* result = await axios.get(window.baseurl + "merchants/org/" + this.orgId, {
                "headers": {'Authorization': 'Bearer ' + this.accessToken} 
              }); */
            result = await axios.get(window.baseurl+"devices/acq/"+this.$route.params.id, {
              params: { page: page2 },
              headers: { 'Authorization': 'Bearer ' + this.accessToken  }            
            })   
            
            // console.log("device_object", result);
            this.devices = result.data.records; 
            this.totalItems = result.data.totalRecords 
            this.itemsPerPage = result.data.pageSize
            this.totalPages = result.data.totalPages
          }
          
          
        } 
        catch (error){            
            //this.show_toast(true, "warning", error.message);
            this.$root.vtoast.showError({message: error.response.data.message})
        }
      },


      async searchDevice() {        
        
        let result;
        let page2 = this.page - 1;
        try{

          if(this.global_permissions.includes("ROLE_STAFF_ADMIN", 'ROLE_STAFF_USER')){            
            result = await axios.get(window.baseurl+"devices/search", {
              params: { page: page2 , search: this.query  },
              headers: { 'Authorization': 'Bearer ' + this.accessToken  }            
            }) 
            
            // console.log("device_object_search", result);
            this.devices = result.data.records; 
            this.totalItems = result.data.totalRecords 
            this.itemsPerPage = result.data.pageSize
            this.totalPages = result.data.totalPages
          }
          else if(this.global_permissions.includes("ROLE_USER_ADMIN", 'ROLE_VIEW_DEVICE')){
            
            result = await axios.get(window.baseurl + "devices/acq/search/" + this.$route.params.id, {
              params: { page: page2 , search: this.query },
              headers: { 'Authorization': 'Bearer ' + this.accessToken  }            
            })   
            
            // console.log("device_object", result);
            this.devices = result.data.records; 
            this.totalItems = result.data.totalRecords 
            this.itemsPerPage = result.data.pageSize
            this.totalPages = result.data.totalPages
          }
          
          
        } 
        catch (error){            
            //this.show_toast(true, "warning", error.message);
            this.$root.vtoast.showError({message: error.response.data.message})
        }
      },

    },
    //get list of acquirers
    async mounted(){
      this.checkTokenExpiry(); 

      //get device list
      this.fetchData();     

      
    }

  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  h3 {
    margin: 40px 0 0;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }

  </style>
  